// Fonction spéciale sans génération de code JS (traitement côté worker)
export default {
  functionKey: "DEUX POINTS",
  title: "PARSER",
  group: "Texte",
  origin: [],
  arguments: [],
  maxArguments: 2,
  showTypeOptions: { origin: false, target: false, arguments: false },
  requiredArguments: [{ argumentKey: "Separator", name: "Séparateur" }],
  expectedArguments: [
    { name: "Séparateur", argumentKey: "Separator", single: true, initialValue: "" },
    { name: "(Optionnel) Préfixe des noms de colonne", argumentKey: "ColPrefix", single: true, initialValue: "" }
  ],
  isStarred: false,

  generate: null
}
